import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import "@/assets/css/theme.css";
import "@github/time-elements";

import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import VueApollo from "vue-apollo";
import moment from "moment";
import { library } from "@fortawesome/fontawesome-svg-core";
// import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import VTooltip from "v-tooltip";

Vue.config.productionTip = false;

console.log(fab);
library.add(fab);
library.add(fas);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VTooltip);
const httpLink = new HttpLink({
  uri: "http://localhost:4000/graphql"
});

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  connectToDevTools: true
});

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

Vue.filter("dateFormat", function (value, dateFormat = null) {
  if (value) {
    if (dateFormat === null) {
      dateFormat = "DD-MM-YYYY hh:mm";
    }
    return moment(String(value)).format(dateFormat);
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
  apolloProvider
}).$mount("#app");
